import { render, staticRenderFns, recyclableRender, components } from "./main.vue?vue&type=template&id=e1af2748&scoped=true&"
var renderjs
import script from "./main.vue?vue&type=script&lang=js&"
export * from "./main.vue?vue&type=script&lang=js&"
import style0 from "./main.vue?vue&type=style&index=0&id=e1af2748&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1af2748",
  null,
  false,
  components,
  renderjs
)

export default component.exports